import { Box } from '@material-ui/core';
import { Channel } from '@nemuru-eng/js-api-client';

import { OverviewDetailRow } from '../../../../shared/components/OverviewDetailRow';
import { Text } from '../../../../shared/components/Text';

export const Details = ({ currentChannel }: { currentChannel: Channel }) => {
  return (
    <Box display={'flex'} flexDirection={'column'} mb={4}>
      <OverviewDetailRow field={<Text tId={'CHANNEL_ID'} />} value={currentChannel.id} copyButton />
    </Box>
  );
};
